import React from 'react';
import {
  BrowserRouter,
  Routes,
  Route,
} from "react-router-dom";
import Home from "./page/Home/Home";
import Login from "./page/LoginForm/Login";
import { Cart, Product, Profile, UserManager, News, Search, CMS } from "./page";
import MainLayout from "./components/Layout/MainLayout";
import { CartProvider } from "./context/CartContext";
import NewsDetail from "./page/News/NewsDetails";
import { AuthProvider } from "./context/AuthContext";
import AuthWrapper from './components/AuthWrapper/AuthWrapper';
import ProtectedRoute from './components/ProtectedRoute/ProtectedRote';

// import your route components too
function App() {
  return (
  
    <AuthProvider>
      <CartProvider>
        <BrowserRouter basename="/">
          <AuthWrapper>
            <Routes>
              {/* Trang Login không có Header/Footer */}
              <Route path="/" element={<Login />} />

              {/* Các trang còn lại dùng Layout có Header/Footer */}
              <Route element={<MainLayout />}>
                <Route path="/Home" element={<Search />} />
                <Route path="/Search" element={<Search />} />
                <Route path="/Cart" element={<Cart />} />
                <Route path="/Product" element={<Product />} />
                <Route path="/News" element={<News />} />
                <Route path="/News/:slug" element={<NewsDetail />} />
              </Route>
              <Route path="/Profile" element={<Profile />} />
              <Route path="/UserManager" element={<UserManager />} />
              <Route path="/CMS" element={
                <ProtectedRoute allowedUserTypes={[1]}>
                  <CMS />
                </ProtectedRoute>
              } />
            </Routes>
          </AuthWrapper>
        </BrowserRouter>
      </CartProvider>
    </AuthProvider>

  );

}

export default App;
